export default (settings: any) => settings['entities'] * settings['security'] * (1 / 60) * 10
